// Watching and driving a v86 guest's serial console (pure: bytes in, keystrokes out, no DOM), so it
// can be tested byte by byte. Used by main.js for the pinned Alpine image's one-click setup.

// Terminal control sequences are removed before matching: BusyBox's line editor follows its prompt
// with a cursor-position query (ESC[6n), so the raw stream never ends in "# ".
const ANSI_RE = /\x1b\[[0-9;?]*[ -/]*[@-~]|\x1b\][^\x07\x1b]*(?:\x07|\x1b\\)|\x1b[()][A-Za-z0-9]|\x1b[=>78]/g;
export const stripAnsi = (s) => s.replace(ANSI_RE, "");

// Returns feed(bytes) -> true once the console shows a login or shell prompt.
export function promptWatcher() {
	const dec = new TextDecoder();
	let tail = "";
	return (bytes) => { tail = stripAnsi(tail + dec.decode(bytes, { stream: true })).slice(-120); return /login: $|[#$] $/.test(tail); };
}

// Fresh boot of the pinned Alpine ISO, typed visibly into the console (nothing hidden):
//   1. syslinux "boot:" prompt (1 s, label "virt"; typed options are appended to its APPEND line):
//      add the serial console so boot messages stream into the Console tab, not just the VGA screen;
//   2. "login:" -> root (the live ISO has no password);
//   3. first shell prompt -> set the terminal size, bring up the network (if allowed), mount the 9p share.
// Stops after step 3 or after `maxMs`. `send(text)` types into the guest.
export function createGuestAssistant({ alpine, network, mountCommand, sharePath, send, size, now = Date.now, maxMs = 600000 }) {
	const dec = new TextDecoder();
	const started = now();
	let tail = "", step = 0, bootLine = false;
	return {
		get done() { return step > 1; },
		feed(bytes) {
			if (step > 1 || now() - started > maxMs) return;
			tail = stripAnsi(tail + dec.decode(bytes, { stream: true })).slice(-200);
			if (alpine && !bootLine && step === 0 && /boot: $/.test(tail)) { bootLine = true; tail = ""; send("virt console=tty0 console=ttyS0,115200\n"); return; }
			if (step === 0 && /login: $/.test(tail)) { step = 1; tail = ""; send("root\n"); return; }
			if (step === 1 && /:~# $/.test(tail)) {
				step = 2;
				const net = network ? "ip link set eth0 up && udhcpc -q -i eth0 >/dev/null 2>&1; " : "";
				// A serial console can't report its size, so tell the guest the terminal's real size.
				const dims = size && size();
				const stty = dims && dims.cols > 0 && dims.rows > 0 ? "stty cols " + dims.cols + " rows " + dims.rows + "; " : "";
				send(stty + net + mountCommand + " 2>/dev/null; echo 'Re:Vault: " + (network ? "network is up, " : "") + "files you send appear in " + sharePath + "'\n");
			}
		},
	};
}
